export default __webpack_public_path__ + "static/media/horiseon.6f1059d4.png";